import './550waterfront/style';
import FormStructure from './550waterfront/form_structure';

export default FormStructure;